import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Layout } from './components/Layout';
import { JobProvider } from './components/JobToast';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { SearchPage } from './pages/SearchPage';
import { DiscoverPage } from './pages/DiscoverPage';
import { SourcesPage } from './pages/SourcesPage';
import { IngestPage } from './pages/IngestPage';
import { LookupPage } from './pages/LookupPage';
import { BookmarksPage } from './pages/BookmarksPage';
import { CasesPage } from './pages/CasesPage';
import { CaseWorkspacePage } from './pages/CaseWorkspacePage';
import { UsersPage } from './pages/UsersPage';
import { JobsPage } from './pages/JobsPage';
import { TelegramPage } from './pages/TelegramPage';
import { AlertsPage } from './pages/AlertsPage';
import { TasksPage } from './pages/TasksPage';

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="login-wrap muted">Laden…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <Protected>
            <JobProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/discover" element={<DiscoverPage />} />
                  <Route path="/sources" element={<SourcesPage />} />
                  <Route path="/ingest" element={<IngestPage />} />
                  <Route path="/lookup" element={<LookupPage />} />
                  <Route path="/bookmarks" element={<BookmarksPage />} />
                  <Route path="/cases" element={<CasesPage />} />
                  <Route path="/cases/:id" element={<CaseWorkspacePage />} />
                  <Route path="/alerts" element={<AlertsPage />} />
                  <Route path="/tasks" element={<TasksPage />} />
                  <Route path="/jobs" element={<JobsPage />} />
                  <Route path="/telegram" element={<TelegramPage />} />
                  <Route path="/users" element={<UsersPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </JobProvider>
          </Protected>
        }
      />
    </Routes>
  );
}
